module.exports = __webpack_public_path__ + "static/media/thala.e73dd951.jpeg";